import {
  REQUEST_DESIGNS_LIST_LOAD,
  DESIGNS_LIST_LOAD_RESPONSE,
  DESIGNS_LIST_LOAD_FAIL,
  LOAD_SHARED_DESIGNS_REQUEST,
  LOAD_SHARED_DESIGNS_RESPONSE,
  LOAD_SHARED_DESIGNS_FAIL
} from '../actions/designs-list';

import {
  REQUEST_DESIGNS_CATEGORIES_LOAD,
  DESIGNS_CATEGORIES_LOAD_RESPONSE,
  DESIGNS_CATEGORIES_LOAD_FAIL
} from '../actions/designs-categories';

import { SELECT_DESIGN, TOGGLE_THANKS_PAGE } from '../actions/ui';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case TOGGLE_THANKS_PAGE: {
      return {
        ...state,
        selectedDesignId: null,
        thanksShowed: !state.thanksShowed
      };
    }
    case SELECT_DESIGN: {
      return {
        ...state,
        selectedDesignId: action.payload.id
      };
    }
    case REQUEST_DESIGNS_LIST_LOAD: {
      return {
        ...state,
        ownDesignsList: {
          ...state.ownDesignsList,
          hasMore: true,
          isLoading: true,
          isLoadFailed: false
        }
      };
    }
    case DESIGNS_LIST_LOAD_RESPONSE: {
      const oldItems = state.ownDesignsList.items || [];
      const items = action.payload.pushItems
        ? oldItems.concat(action.payload.items)
        : action.payload.items;

      return {
        ...state,
        ownDesignsList: {
          ...state.ownDesignsList,
          isLoading: false,
          isLoadFailed: false,
          hasMore: action.payload.hasMore,
          items: items
        }
      };
    }
    case DESIGNS_LIST_LOAD_FAIL: {
      return {
        ...state,
        ownDesignsList: {
          ...state.ownDesignsList,
          isLoading: false,
          isLoadFailed: true
        }
      };
    }
    case LOAD_SHARED_DESIGNS_REQUEST: {
      return {
        ...state,
        sharedDesigns: {
          ...state.sharedDesigns,
          hasMore: true,
          isLoading: true,
          isLoadFailed: false
        }
      };
    }
    case LOAD_SHARED_DESIGNS_RESPONSE: {
      const oldItems =
        state.sharedDesigns.categoryItems[action.payload.categoryId] || [];
      const items = action.payload.pushItems
        ? oldItems.concat(action.payload.items)
        : action.payload.items;
      return {
        ...state,
        sharedDesigns: {
          ...state.sharedDesigns,
          categoryItems: {
            ...state.sharedDesigns.categoryItems,
            [action.payload.categoryId]: items
          },
          hasMore: action.payload.hasMore,
          isLoading: false,
          isLoadFailed: false
        }
      };
    }
    case LOAD_SHARED_DESIGNS_FAIL: {
      return {
        ...state,
        sharedDesigns: {
          ...state.sharedDesigns,
          isLoading: false,
          isLoadFailed: true
        }
      };
    }
    case REQUEST_DESIGNS_CATEGORIES_LOAD: {
      return {
        ...state,
        designsCategories: {
          ...state.designsCategories,
          isLoading: true,
          isLoadFailed: false
        }
      };
    }
    case DESIGNS_CATEGORIES_LOAD_RESPONSE: {
      return {
        ...state,
        designsCategories: {
          ...state.designsCategories,
          isLoading: false,
          isLoadFailed: false,
          items: action.payload.items,
          children: action.payload.children
        }
      };
    }
    case DESIGNS_CATEGORIES_LOAD_FAIL: {
      return {
        ...state,
        designsCategories: {
          ...state.designsCategories,
          isLoading: false,
          isLoadFailed: true
        }
      };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/root.js